import { render, staticRenderFns } from "./SearchJournalTickets.vue?vue&type=template&id=26bf60cc&scoped=true"
import script from "./SearchJournalTickets.vue?vue&type=script&lang=js"
export * from "./SearchJournalTickets.vue?vue&type=script&lang=js"
import style0 from "./SearchJournalTickets.vue?vue&type=style&index=0&id=26bf60cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26bf60cc",
  null
  
)

export default component.exports